import styled from 'styled-components';

const Button = styled.button`
  display: block;
  width: 32px;
  height: 32px;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: 'Pluto Sans Bold';
  background-color: transparent;
  opacity: 0.8;

  @media (hover: hover) {
    &:hover {
      opacity: 1;
    }
  }

  &:active {
    opacity: 1;
  }

  svg {
    display: block !important; // ugly but better then inline using style={{ display: block }}
    margin: 0 auto;
    width: 24px !important;
    height: 24px !important;
    color: #ffffff !important;
    position: relative;
    top: 5px;
  }

  transition: opacity 0.3s linear;
`;

const EpisodeData = styled.div`
  margin-bottom: 0.4em;
  position: relative;
  z-index: 2;
`;

const MD = styled.span``;

const s = {
  wrapper: styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  `,

  copyWrapper: styled.div`
    display: block;
    margin-bottom: 90px;
    flex: ${(props) => (props.visible ? 2 : 1)} 1 0;
    transition: flex-grow 0.3s linear;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: ${(props) => (props.playerIsFullscreen ? '5px 34px' : 0)};
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;

    @media (max-width: 767px) {
      padding-bottom: 25px;
    }

    @media (max-width: 480px) {
      display: ${(props) => (props.playerIsFullscreen ? 'block' : 'none')};
      margin-bottom: ${(props) => (props.playerIsFullscreen ? '60px' : 0)};
      padding: ${(props) => (props.playerIsFullscreen ? '20px 10px' : 0)};
    }
    // [WWW-1938] raises overlay info to compensate for browser address bar (in landscape mode in Android mobile devices)
    @media (max-width: 960px) and (orientation: landscape) {
      ${(props) => (props.isAndroid && !props.isFullscreen ? 'bottom: 10vh;' : '')}
    }
  `,

  copyWrapperMinimized: styled.div`
    height: 42px;
    position: absolute;
    bottom: 10px;
    left: 120px;
    > div:first-of-type {
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 58vw;
    }
  `,

  gradient: styled.div`
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      -180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) 31%,
      rgba(0, 0, 0, 0.9) 60%,
      rgba(0, 0, 0, 1) 100%
    );
    height: 220px;

    @media (max-width: 480px), (orientation: landscape) and (max-width: 767px) {
      display: ${({ playerIsFullscreen }) => (playerIsFullscreen ? 'block' : 'none')};
      background: linear-gradient(
        -180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.3) 31%,
        rgba(0, 0, 0, 0.53) 60%,
        rgba(0, 0, 0, 0.65) 100%
      );
      height: 180px;
    }
  `,

  channelLogo: styled.div`
    width: 210px;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 20px;

    img {
      width: 100%;
    }

    @media (max-width: 768px) {
      display: none;
    }
  `,

  poster: styled.div`
    height: 273px;
    width: 120px;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 20px;
    position: relative;
    img {
      width: 100%;
    }

    @media (max-width: 768px) {
      display: none;
    }
  `,

  content: styled.div`
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
  `,

  contentWrapper: styled.div`
    display: flex;
  `,

  episode: styled.div`
    display: inline-block;
    color: rgb(255, 255, 255);
    font-family: 'Pluto Sans SemiBold';
    line-height: 22px;
    font-size: 16px;
    font-weight: 400;
    height: 22px;
    letter-spacing: 0.2px;
    overflow: hidden;

    @media (max-width: 480px), (orientation: landscape) and (max-width: 767px) {
      font-size: ${(props) => (props.playerIsFullscreen ? '12px' : '16px')};
      line-height: 14px;
      height: 17px;
    }
  `,

  rating: styled.div`
    font-family: 'Pluto Sans Medium';
    font-size: 10px;
    line-height: 10px;
    color: #ffffff;
    border-radius: 4px;
    border: 1px solid rgb(255, 255, 255);
    width: fit-content;
    text-align: center;
    display: inline-block;
    padding: 4px 6px 0 6px;
    margin-right: 15px;

    @media (max-width: 480px), (orientation: landscape) and (max-width: 767px) {
      font-size: 10px;
      flex-shrink: 0;
      height: 15px;
      padding: 0 4px;
      margin-right: 5px;
    }
  `,

  ratingImg: styled.img`
    height: 20px;
    width: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  `,

  title: styled.div`
    font-family: 'Pluto Sans Bold';
    color: rgb(255, 255, 255);
    font-size: 48px;
    letter-spacing: 0.52px;
    line-height: 63px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${(props) => (props.playerIsFullscreen ? '2' : '1')};
    margin-bottom: 10px;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 1.3;
      margin-bottom: 5px;
    }
  `,

  infoButton: styled(Button)`
    @media (min-width: 768px) {
      margin-bottom: -8px;
    }
  `,

  volumeWrapper: styled.div`
    position: absolute;
    bottom: ${(props) => (props.playerIsFullscreen ? '16px' : '12px')};
    left: ${(props) => (props.playerIsFullscreen ? '24px' : '9px')};
    opacity: ${(props) => (props.visible ? '0' : '1')};
    display: ${(props) => (props.isMuted && !props.isStopped ? 'flex' : 'none')};
    div {
      width: ${(props) => (props.isMuted ? '36px !important' : '')};
    }
    span,
    div div {
      display: ${(props) => (props.isMuted ? 'none' : '')};
    }
    svg {
      position: absolute;
      top: 8px;
      left: 7px;
    }
    // for Homepage L1 player
    @media (max-width: 160px) {
      display: none;
    }
    // [WWW-1938] raises overlay info to compensate for browser address bar (in landscape mode in Android mobile devices)
    @media (max-width: 960px) and (orientation: landscape) {
      ${(props) => (props.isAndroid && !props.isFullscreen ? 'bottom: 10vh;' : '')}
    }
  `,

  videoControllsWrapper: styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: ${(props) => (props.playerIsFullscreen ? 0 : '')};
    bottom: 0;
    opacity: ${(props) => (props.visible ? '1' : '0')};
    transition: opacity 0.2s linear, ${(props) => (!props.visible ? '0.15s' : '.15s')} linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px 8%;
    pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
    z-index: 2;
    @media (max-width: 767px) {
      padding-bottom: 25px;
      max-width: none;
      max-height: none;
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 70px;
      pointer-events: none;
    }

    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 320px;
      pointer-events: none;
    }

    @media (max-width: 480px), (orientation: landscape) and (max-width: 767px) {
      bottom: ${(props) => !props.playerIsFullscreen && '0'};
      opacity: ${(props) => !props.playerIsFullscreen && '1'};
    }
    // [WWW-1938] raises overlay info to compensate for browser address bar (in landscape mode in Android mobile devices)
    @media (max-width: 960px) and (orientation: landscape) {
      ${(props) => (props.isAndroid && !props.isFullscreen ? 'bottom: 10vh;' : '')}
    }
  `,

  panel: styled.div`
    flex: ${(props) => (!props.playerIsFullscreen ? 2 : 1)} 1 0;
    transition: flex-grow 0.3s linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 90px;
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 2;

    @media (max-width: 767px) {
      padding-bottom: 25px;
    }
  `,

  episodeSeriesName: styled(EpisodeData)`
    font-size: 36px;
    line-height: 46px;
    font-weight: 900;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  `,

  episodeName: styled(EpisodeData)`
    font-family: 'Pluto Sans Bold';
    font-size: 24px;
    line-height: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${(props) => (props.playerIsFullscreen ? '2' : '1')};
    display: none;

    svg {
      color: #fff !important;
      position: relative;
      top: 3px;
    }

    &:before {
      content: open-quote;
    }
    &:after {
      content: close-quote;
    }

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 1.3;
    }

    @media (min-width: 401px) {
      display: ${(props) => (props.playerIsFullscreen ? '-webkit-box' : 'none')};
    }
  `,

  episodeDescription: styled(EpisodeData)`
    font-size: 18px;
    line-height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    display: none;

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 1.3;
    }

    @media (min-width: 401px) {
      display: ${(props) => (props.playerIsFullscreen ? '-webkit-box' : 'none')};
    }
  `,

  metadata: styled.div`
    font-size: 18px;
    margin-bottom: 1.4em;
    display: ${(props) => (props.playerIsFullscreen ? '-webkit-box' : 'none')};

    ${MD} + ${MD} {
      margin-left: 2em;
      position: relative;
    }
    ${MD} + ${MD}:before {
      content: '.';
      position: absolute;
      top: -16px;
      left: -25px;
      font-size: 30px;
    }

    @media (max-width: 767px) {
      font-size: 12px;
    }
  `,

  MD,
};

export default s;
